import React, { createContext } from "react";
import { SelectedOptinalPreferences, Step } from "./constants/steps";
import { ConnecteeSubmission } from "./types/connecteeSubmission";

export interface FormData {
  forWhom: string;
  formattedAddress: string;
  placeId: string;
  location: Record<string, unknown>;
  email: string;
  phone: string;
  firstName: string;
  lastName: string;
  country: string;
  state: string;
  city: string;
  howToContact: string;
  additionalInfo: string | null;
  providerClinicalSpecialties: string[];
  providerGender: string;
  providerAgeGroups: string;
  providerCertifications: string;
  providerDeliveryOptions: string;
  providerModalities: string;
  providerLanguage: string;
}

export interface ContactInfoErrors {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
}

export interface AppContextType {
  activeSteps: Step[];
  currentStep: number;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
  handleNextStep: () => void;
  handlePrevStep: () => void;
  form: FormData;
  updateForm: (newData: Partial<FormData>) => void;
  selectedOptionalPreferences: SelectedOptinalPreferences[];
  setSelectedOptionalPreferences: React.Dispatch<React.SetStateAction<SelectedOptinalPreferences[]>>;
  isSubmissionCreated: boolean;
  setIsSubmissionCreated: React.Dispatch<React.SetStateAction<boolean>>;
  submission: ConnecteeSubmission | null;
  setSubmission: React.Dispatch<React.SetStateAction<ConnecteeSubmission | null>>;
  handleNewError: (errMessage: string) => void;
  contactInfoErrors: ContactInfoErrors;
  setContactInfoErrors: React.Dispatch<React.SetStateAction<ContactInfoErrors>>;
}

export const AppContext = createContext<AppContextType>({} as AppContextType);
